import { formatDateTimeUrlDate } from 'common/UrlDate';
import { DateTime, Duration } from 'luxon';
import { GetFormattedAvailbilityDatesProps, QuantityType } from './types';

export const createBlankQuantityList = (): QuantityType => ({});

export const isPreviousDate = (currentDate: DateTime) => currentDate.diff(DateTime.now(), 'days').days < 0;

export const isDateTomorrow = (currentDate: string) => {
  const tomorrowUrlDate = formatDateTimeUrlDate(DateTime.now().plus({ days: 1 }));
  return currentDate === tomorrowUrlDate;
};

export const generateThreeWeekCalendar = (availableDeliveryDays?: QuantityType) => {
  const today = DateTime.now();
  const firstDateOfWeek = today.startOf('week').minus(Duration.fromObject({ day: 1 }));
  const lastDateOfThirdWeek = firstDateOfWeek.plus(Duration.fromObject({ week: 3 }));
  const totalNumberOfDays = lastDateOfThirdWeek.diff(firstDateOfWeek, ['days']).days + 1;
  return Array.from({ length: totalNumberOfDays ?? 0 }).map((_, additionalDay) => {
    const dateTime = firstDateOfWeek?.plus(Duration.fromObject({ day: additionalDay }));
    const dateString = formatDateTimeUrlDate(dateTime);
    return { date: dateString, count: availableDeliveryDays ? availableDeliveryDays[dateString] ?? 0 : 0 };
  });
};

export const getFormattedAvailabilityDates = (props: GetFormattedAvailbilityDatesProps) => {
  const { availableDeliveryDays } = props;
  const listOfDays = availableDeliveryDays.reduce(
    (acc, curr) => ({ ...acc, [curr.date]: curr.count || 0 }),
    createBlankQuantityList()
  );
  return generateThreeWeekCalendar(listOfDays);
};
